import 'util';

export class ApiHelper {
  doFetchAsync = async (url, options, onSuccess, onFailure, signal) => {
    await fetch(url, options, { signal: signal })
      .then(this.handleResponseStatus)
      .then((response) => response.json())
      .then((data) => this.handleCallback(data, onSuccess))
      .catch((error) => this.handleError(error, url, onFailure));
  };

  getDataAsync = async (url, onSuccess, onFailure, signal) => {
    const getOptions = {
      method: 'GET'
    };

    await this.doFetchAsync(url, getOptions, onSuccess, onFailure, signal);
  };

  getDataSecureAsync = async (url, token, onSuccess, onFailure, signal) => {
    const getOptions = {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${token}`
      }
    };

    await this.doFetchAsync(url, getOptions, onSuccess, onFailure, signal);
  };

  getOptions(data, httpVerb, headers = null) {
    if (headers === null) {
      headers = {
        'Content-Type': 'application/json; charset=utf-8;',
        'Access-Control-Allow-Origin': 'origin',
        'Cache-Control': 'no-store',
        'Feature-Policy': '<directive><allowlist>',
        'Referrer-Policy': 'no-referrer',
        'X-XSS-Protection': '1; mode=block',
        'Set-Cookie': 'flavor=choco; SameSite=Strict; Secure;'
      };
    } else {
      headers = {
        ...headers,
        'Content-Type': 'application/json; charset=utf-8;',
        'Cache-Control': 'no-store',
        'Feature-Policy': '<directive><allowlist>',
        'Referrer-Policy': 'no-referrer',
        'X-XSS-Protection': '1; mode=block',
        'Set-Cookie': 'flavor=choco; SameSite=Strict; Secure;'
      };
    }

    const options = {
      method: httpVerb,
      mode: 'same-origin',
      Pragma: 'no-cache',
      headers: headers,
      body: JSON.stringify(data)
    };

    return options;
  }

  postDataAsync = async (
    url,
    data,
    onSuccess,
    onFailure,
    signal,
    headers = null
  ) => {
    const postOptions = this.getOptions(data, 'POST', headers);

    await this.doFetchAsync(url, postOptions, onSuccess, onFailure, signal);
  };

  postDataSecureAsync = async (
    url,
    data,
    token,
    onSuccess,
    onFailure,
    signal
  ) => {
    const headers = {
      Authorization: `Bearer ${token}`
    };
    const postOptions = this.getOptions(data, 'POST', headers);

    await this.doFetchAsync(url, postOptions, onSuccess, onFailure, signal);
  };

  postDataWithResponseSecure(url, data, token, onSuccess, onFailure, signal) {
    const postOptions = {
      method: 'POST',
      mode: 'same-origin',
      cache: 'no-cache',
      headers: {
        'Content-Type': 'application/json; charset=utf-8',
        Authorization: `Bearer ${token}`
      },
      body: JSON.stringify(data)
    };

    console.log('postDataWithResponse ...');

    const postResponse = fetch(url, postOptions, { signal: signal })
      .then(this.handleResponseStatus)
      .then((response) => response.json())
      .then((data) => this.handleCallback(data, onSuccess))
      .catch((error) => this.handleError(error, url, onFailure));

    return postResponse;
  }

  putDataSecureAsync = async (
    url,
    data,
    token,
    onSuccess,
    onFailure,
    signal
  ) => {
    const headers = {
      Authorization: `Bearer ${token}`
    };
    const putOptions = this.getOptions(data, 'PUT', headers);

    await this.doFetchAsync(url, putOptions, onSuccess, onFailure, signal);
  };

  deleteData(url, data, callback) {
    const deleteOptions = {
      method: 'DELETE',
      mode: 'same-origin',
      cache: 'no-cache',
      headers: { 'Content-Type': 'text/plain;charset=UTF-8' },
      body: data
    };

    const deleteResponse = fetch(url, deleteOptions)
      .then((response) => {
        if (callback !== null) {
          callback(response);
        }
      })
      .catch((error) => console.log('Error:' + error));

    return deleteResponse;
  }

  handleResponseStatus(response) {
    if (!response.ok) {
      console.log(`status: ${response.statusText}`);
      throw new Error(response.statusText);
    }
    return response;
  }

  handleError(error, url, callback) {
    console.log('Fetch URL: ' + url);
    console.error(error);
    this.handleCallback(error, callback);
  }

  handleCallback(data, callback) {
    if (callback != null) {
      callback(data);
    }
  }
}
